<!--
/**
* @name: Detail.vue
* @description: 消息详情页面
* @author: 杨波
* @create: 2020/11/05 11:11:37
* @update: 2020/1/05 11:11:37
*/
-->
<template>
  <y-view :loading="isLoading">
    <k-table :data="logsList" height="calc(100vh - 40px)" :rightFixedNumber="1" :columns="initColumns()"></k-table>
  </y-view>
</template>
<script>
import { NESTLE_TRADE_BACK_SERVER_MQ_SEND_TASK_LOGS } from "@/assets/modules/apiList";
export default {
  data() {
    return {
      isLoading: false,
      logsList: [],
      queueNameList: [
        {
          value: "EARNING_CREATE",
          label: "收益创建",
        },
        {
          value: "EARNING_CONFIRM",
          label: "收益确认",
        },
        {
          value: "EARING_CANCEL",
          label: "收益取消",
        },
        {
          value: "GOODS_SALE_ADD",
          label: "商品增加销量",
        },
        {
          value: "ORDER_RECEIVE_CONFIRM",
          label: "延时自动确认收货",
        },
        {
          value: "ORDER_NESTLE_CANCEL_DELAY",
          label: "延时自动取消订单",
        },
        {
          value: "ORDER_CREATE",
          label: "推送订单到订单中心",
        },
        {
          value: "PAY_CREATE",
          label: "推送支付单到订单中心",
        },
        {
          value: "ORDER_CANCEL",
          label: "推送订单取消状态到订单中心",
        },
        {
          value: "ORDER_CANCEL_DELAY",
          label: "延时推送订单取消状态到订单中心",
        },
      ],
    };
  },
  watch: {},
  computed: {},
  methods: {
    initColumns() {
      return [
        {
          name: "ID",
          field: "id",
          style: {
            width: 80,
            textAlign: "center",
          },
        },
        {
          name: "队列名称",
          field: "queueName",
          style: {
            width: 80,
            textAlign: "center",
            "white-space": "normal",
            "line-height": "20px",
          },
          customRender: (row) => {
            let temp = "";
            for (let i = 0; i < this.queueNameList.length; i++) {
              if (row.queueName == this.queueNameList[i].value) {
                temp = this.queueNameList[i].label;
                break;
              }
            }
            return <div>{temp}</div>;
          },
        },
        {
          name: "消息标识",
          field: "tagNo",
          style: {
            width: 150,
            textAlign: "center",
            "white-space": "normal",
            "line-height": "20px",
          },
        },
        {
          name: "消息内容",
          field: "message",
          style: {
            width: 150,
            textAlign: "center",
            "white-space": "normal",
            "line-height": "20px",
          },
        },
        {
          name: "调用队列服务结果",
          field: "result",
          style: {
            width: 180,
            textAlign: "center",
            "white-space": "normal",
            "line-height": "20px",
          },
        },
        {
          name: "延迟时间",
          field: "delaySecond",
          style: {
            width: 80,
            textAlign: "center",
            "white-space": "normal",
            "line-height": "20px",
          },
        },
        {
          name: "是否成功",
          field: "isSuccess",
          style: {
            width: 80,
            textAlign: "center",
          },
          customRender: (row) => {
            return <div>{row.isSuccess ? "成功" : "失败"}</div>;
          },
        },
        {
          name: "创建时间",
          field: "createTime",
          style: { textAlign: "center", width: 130 },
        },
      ];
    },
    getLogsList(id) {
      this.$fetch({
        api: NESTLE_TRADE_BACK_SERVER_MQ_SEND_TASK_LOGS,
        para: { id: id },
      }).then((res) => {
        this.logsList = res || [];
      });
    },
  },
  created() {
    const { id } = this.$route.query;
    if (id) {
      this.getLogsList(id);
    }
  },
  beforeRouteUpdate(to, from, next) {
    const { id } = to.query;
    if (id) {
      this.getLogsList(id);
    }
    next();
  },
};
</script>
<style lang="postcss" module="css"></style>
